import { DateFormatEnum, formatDate } from "../Date/Date";
import { emptyString } from "../Constants/CommonConstants";

export const startWithLowercase = (value: string | null): string => {
  if (!value) {
    return "";
  }

  return value.charAt(0).toLowerCase() + value.slice(1);
};

export const startWithUppercase = (value: string | null): string => {
  if (!value) {
    return "";
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const optionalDateToValue = (format: DateFormatEnum, date?: Date | null): string => {
  return date ? formatDate(date, format) : "-";
};

export const optionalToValue = <Type>(value?: Type | null): string => {
  return getValueOrDefault("-", value);
};

export const optionalStringToValue = (value?: string | null): string => {
  return value ? value : "-";
};

export const optionalToEmptyValue = <Type>(value?: Type | null): string => {
  return getValueOrDefault("", value);
};

const getValueOrDefault = <Type>(defaultValue: string, value?: Type | null): string => {
  return value ? String(value) : defaultValue;
};

export const convertLocalizedNumberStringToFloat = (value: string | null) => {
  const result = parseFloat((value || "").replace(/\./g, "").replace(",", "."));

  return !isNaN(result) ? result : null;
};

export const isValidLocalizedNumberString = (value: string | null) => {
  const parsedValue = parseFloat((value || "").replace(/\./g, "").replace(",", "."));
  return !isNaN(parsedValue);
};

export const stringToPascalCase = (value: string): string => {
  const words = stringToWords(value);

  if (words) {
    return arrayToPascalCase(words);
  }

  return "";
};

function stringToWords(value: string): Array<string> | null {
  const regex =
    /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

  return value.match(regex);
}

// convert the input array to camel case
function arrayToPascalCase(inputArray: Array<string>): string {
  let result = emptyString;

  inputArray.forEach((value, index) => {
    let lowerCaseString = value.toLowerCase();

    if (index !== 0) {
      lowerCaseString = lowerCaseString.substr(0, 1).toUpperCase() + lowerCaseString.substr(1);
    }

    result += lowerCaseString;
  });

  return result;
}

export const trim = (value: string): string => {
  return value.replace(/\s/g, "");
};

export const stringIsNotNullOrUndefined = (value: string | null | undefined) =>
  value !== null && value !== undefined && value !== "";
